/*
 * @Descripttion: 
 * @Author: yeyancheng
 * @Date: 2022-01-22 09:20:10
 * @LastEditors: Dom
 * @LastEditTime: 2022-07-27 13:38:21
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import { queryCurrent, queryMessage } from "@/services/user";
import { removeToken } from "@/utils/localToken";
import { UserInfoParams, UserExtend, UserEnterprise } from "@/services/data.d";

export interface CurrentUser {
	certStatus: number;
	contStatus: number;
	createdAt?: string;
	email: string;
	id: number;
	password: string;
	phone: string;
	roles: any[];
	updatedAt: string;
	userCode: string;
	userEnterprise?: UserEnterprise | null;
	userExtend?: UserExtend | null;
	userType: number;
	username: string;
  mobilePrefix: string;
}

export interface StateType {
  currentUser: CurrentUser;
  message: number;
}

export interface ModuleType extends StoreModuleType<StateType> {
  state: StateType;
  mutations: {
    saveCurrentUser: Mutation<StateType>;
    saveMessage: Mutation<StateType>;
  };
  actions: {
    fetchCurrent: Action<StateType, StateType>;
    fetchMessage: Action<StateType, StateType>;
    logout: Action<StateType, StateType>;
  };
}

const initState: StateType = {
  currentUser: {
    certStatus: 0,
    contStatus: 0,
    createdAt: '',
    email: "",
    id: 0,
    password: "",
    phone: "",
    roles: [],
    updatedAt: "",
    userCode: "",
    mobilePrefix: '',
    userEnterprise: {
      agentBankCardNo: '',
      agentId: '',
      agentIdAnnex: '',
      agentMobile: '',
      agentName: '',
      agentNameEn: '',
      agentValidityEndDate: '',
      agentValidityStartDate: '',
      auditTime: '',
      bankDepositRegion: '',
      bankId: '',
      bankName: '',
      city: '',
      companyPrincipalType: 0,
      contacts: '',
      contactsPhone: '',
      createdAt: '',
      creditCode: '',
      detailedAddress: '',
      enterpriseCertAnnex: '',
      enterpriseName: '',
      id: 0,
      isForever: false,
      lang: '',
      legalAuthorizedMobile: '',
      legalBankCardNo: '',
      legalId: '',
      legalIdAnnex: '',
      legalIsForever: false,
      legalMobile: '',
      legalName: '',
      legalValidityEndDate: '',
      legalValidityStartDate: '',
      licenseAnnex: '',
      organizationType: '',
      province: '',
      region: '',
      representativeName: '',
      reviewer: '',
      subbranchName: '',
      updatedAt: '',
      userCode: '',
      validityEndDate: '',
      validityStartDate: '',
      agentIsForever: false,
    },
    userExtend: {
      auditTime: "",
			certificateAnnex: "",
			certificateNo: "",
			certificateType: 0,
			city: "",
			createdAt: "",
			detailedAddress: "",
			id: 0,
			isForever: true,
			nameCn: "",
			nameEn: "",
			nationality: "",
			phone: "",
			province: "",
			region: "",
			reviewer: "",
			updatedAt: "",
			userCode: "",
			validityEndDate: "",
			validityStartDate: "",
      bankId: '',
      bankName: '',
      subbranchName: '',
      bankDepositRegion: '',
    },
    userType: 0,
    username: "",
  },
  message: 0,
}

const StoreModel: ModuleType = {
  namespaced: true,
  name: 'user',
  state: {
    ...initState
  },
  mutations: {
    saveCurrentUser(state, payload) {
      state.currentUser = payload
    },
    saveMessage(state, payload) {
      state.message = payload;
    }
  },
  actions: {
    async fetchCurrent({ commit },params:UserInfoParams) {
      try {
        const response: ResponseData = await queryCurrent(params);
        const { body } = response;
        const obj:any = body
        const usermsg = {
          id: obj.id,
          userCode: obj.userCode,
          userName: obj.username,
          email: obj.email,
          certStatus: obj.certStatus,
          contStatus: obj.contStatus,
          userType: obj.userType,
          phone: obj.phone,
          createdAt: obj.createdAt
        }
        commit('saveCurrentUser', body || {});
        localStorage.setItem('userMsg',JSON.stringify(usermsg))
        return true;
      } catch (error) {
        return false;
      }
    },
    async fetchMessage({ commit }) {
      try {
        const response: ResponseData = await queryMessage();
        const { data } = response;        
        commit('saveMessage', data || 0);
        return true;
      } catch (error) {
        return false;
      }
    },
    async logout({ commit }) {
      try {
        await removeToken();
        commit('saveCurrentUser', { ...initState.currentUser });
        return true;
      } catch (error) {
        return false;
      }
    }
  }
}



export default StoreModel;
